<template>
  <div class="list">
    <div class="header">
      <div class="l" />
      <div class="r">
        <el-input
          v-model="searchForm.realName"
          placeholder="请输入真实姓名"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      searchForm: {
        realName: '',
        pageNum: 1,
        pageSize: 10,
      },
      tabelData: {},
      tableColumn: [
        {
          key: 'realName',
          label: '真实姓名',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'wechatNickName',
          label: '微信昵称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '手机号码',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'totalAuditAmount',
          label: '总审核金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'extractAuditAmount',
          label: '已提取金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'control',
          label: '操作',
          width: '70px',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.distribution.pageVideoAuditSummary(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'DistributionDetails', params: { id: item.auditUserId, type: 'video' } });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
      }
    }
    .r {
      display: flex;
      align-items: center;
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
    }
  }
}
</style>
